module.exports = __webpack_public_path__ + "static/media/alDoor.bcb868b2.jpeg";